import { Navigate } from "react-router-dom"
import { ROUTES } from "@/routes/path"

export default function Base() {
  return <Navigate to={ROUTES.DASHBOARD.STUDIO.INDEX} replace />
}
